import React from "react";
import { List, ListItem, Skeleton, Stack } from "@mui/material";
import { SkeletonDetailRows } from "../../common/Utils/Skeleton/SkeletonComponents";

const PreAuthorizationTabSkeleton = ({ count = 3 }) => (
  <List disablePadding>
    {Array.from({ length: count }).map((_, i) => (
      <ListItem key={i} divider={i < count - 1}>
        <Stack sx={{ width: '100%' }} spacing={1}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Skeleton variant="text" width="60%" height={28} />
            <Skeleton variant="circular" width={36} height={36} />
          </Stack>
          <SkeletonDetailRows widths={['40%', '35%']} />
        </Stack>
      </ListItem>
    ))}
  </List>
);

export default PreAuthorizationTabSkeleton;
